import type { GameDto } from '@/game/core/game';
import { formatDuration } from './time';

type PlayerStats = {
    playerId: string;
    name: string;
    team?: string;
    wordsPlayed: number;
    timeouts: number;
    wordLengths: number[];
    responseTimes: number[];
};

export function getMatchStats(data: GameDto) {
    const { game, config } = data;
    if (game?.endState) {
        const totalTimeMs = new Date(game.endState.endedAt).getTime() - new Date(game.startedAt).getTime();
        const boardSize = config.boardSize;

        const turns = Object.values(game.turns || {}).filter(Boolean).sort((a, b) => {
            const aTime = a.playedAt || a.timedOutAt || 0;
            const bTime = b.playedAt || b.timedOutAt || 0;
            return aTime - bTime;
        });

        const playerStats: Record<string, PlayerStats> = {};

        let validTurns = 0;
        let longestWord = '';
        let lastTurnTimestamp = game.startedAt;

        for (let i = 0; i < turns.length; i++) {
            const turn = turns[i];

            if (turn) {
                const resolvedTimestamp = turn.playedAt ?? turn.timedOutAt;

                const player = playerStats[turn.playerId] || {
                    playerId: turn.playerId,
                    name: data.players[turn.playerId]?.name || 'unknown player',
                    team: data.players[turn.playerId]?.team,
                    wordsPlayed: 0,
                    timeouts: 0,
                    wordLengths: [],
                    responseTimes: [],
                };

                if (turn.word?.wordId) {
                    validTurns++;
                    if (turn.word.kana.length > longestWord.length) {
                        longestWord = turn.word.kana;
                    }

                    player.wordsPlayed += 1;
                    player.wordLengths.push(turn.word.kana.length);

                    player.responseTimes.push(Math.max(0, resolvedTimestamp - lastTurnTimestamp));
                } else {
                    if (turn.timedOutAt) {
                        player.timeouts += 1;
                    }
                }

                playerStats[player.playerId] = player
                lastTurnTimestamp = resolvedTimestamp ?? lastTurnTimestamp;;
            }
        }


        return {
            totalMatchTime: formatDuration(totalTimeMs),
            validPlays: validTurns,
            longestWord,
            board: {
                size: boardSize,
                cells: boardSize * boardSize
            }
        }
    }

    throw new Error('No game, no stats');
}
